const isPrivate = (propertyName) => propertyName.startsWith('_');
/**
 * Same as JSON.stringify with some minor modifications:
 * * does not throw exceptions
 * * does not serialize private properties like `_myProp` and therefore hides them
 * * serializes undefined properties as `undefined` instead of completely hiding them
 *
 * @param data
 *
 * @returns the given data as string with JSON-format
 *
 * Alternatively can also return a string in JSON-format with an `exception` and
 * an optional `errorMessage` string if serializing data failed.
 *
 */
export function safeJSONStringify(data) {
    let errorMessage = undefined;
    try {
        return JSON.stringify(data, (key, value) => {
            if (isPrivate(key)) {
                return undefined;
            }
            if (value === undefined) {
                return 'undefined';
            }
            return value;
        });
    }
    catch (e) {
        if (e instanceof Error) {
            errorMessage = e.message;
        }
    }
    return JSON.stringify({ exception: 'UNABLE TO SERIALIZE DATA', errorMessage });
}
//# sourceMappingURL=string-utils.js.map